// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"45f0a8e5","211":"3bfa2a1e","481":"a7d4abdb","702":"ab798f51","787":"2141c8c2","825":"6bc74463"}[chunkId] + ".chunk.js";
};